import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage, } from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import DateInput from '../../widgets/DateInput';
import TextArea from '../../widgets/TextArea';
import CheckBox from '../../widgets/CheckBox';
import ImagePicker from '../../widgets/ImagePicker';
import Specialization from '../../widgets/Specialization';


export function EditProviderEducation() {
    const [state, setState] = useState({provider:null, errors:{}});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getprovider();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getprovider = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/provider/`, config);
            showLoading(dispatch, false);
            // console.log(reply.data.dateOfBirth);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(!reply.data.education?.length > 0) {
                    reply.data.education = [{}]
                }

                setState({
                    ...state,
                    provider: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {education: state.provider.education};

            try {
                const reply = await axios.patch(API_URL + '/provider', data, config);
                showLoading(dispatch, false);
                //console.log(reply);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    //navigateTo(dispatch, navigate, "/provider");
                    navigateTo(dispatch, navigate, -1);
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            provider:{...state.provider,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changeEducation = (index, e) => {
        state.provider.education[index][e.target.id] = e.target.value;
        change('education',state.provider.education);
    };

    const handleEducationNumberChange = (index, e) => {
        state.provider.education[index][e.target.id] = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        change('education',state.provider.education);
    };

    const addError = (errors, index, name, error) => {
        if(!errors.education) {
            errors.education = [];
        }
        while(!errors.education[index]) {
            errors.education.push({});
        }
        errors.education[index][name] = error;
    }

    const validateForm = () => {
        const errors = {};
        for (let index = 0; index < state.provider.education.length; index++) {
            if (!state.provider.education?.[index]?.degree_qualification?.trim()) {
                addError(errors, index, 'degree_qualification', 'degree_qualification_error');
            }
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    const addPackage = (e) => {
        if(state.provider.education?.length < 3) {
            state.provider.education.push({});
            change('education',state.provider.education);
        }
    };

    const removePackage = (index) => {
        if(state.provider.education?.length > 1) {
            state.provider.education.splice(index, 1);
            change('education',state.provider.education);
        }

    };


    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-provider-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.provider?<Background showClouds={true} >
                            <div className='right-main-inner'>
                                <div className='mt40'>
                                    <div className='center-div font-25 font-bold text-align-center'>{t("about")}</div>
                                </div>

                                <div className='mt30'>
                                    <div className='center-div font-20 text-align-center'>{t("qualification_title")}</div>
                                </div>
                                <div>
                                    <div className='center-div font-20 text-align-center'>{t("not_required")}</div>
                                </div>

                                {state.provider.education && state.provider.education.map((item, key) => (
                                    <div key={key}>
                                        <div className='mt30'>
                                            <Input className={state.errors.education?.[key]?.degree_qualification?"error":""} id="degree_qualification" placeholder={t("degree_qualification")} value={item.degree_qualification??''} onChange={(e) => changeEducation(key, e)}/>
                                        </div>
                                        {state.errors.education?.[key]?.degree_qualification && <div className='mt5 error font-12'><Trans i18nKey={state.errors.education?.[key]?.degree_qualification} /></div>}

                                        <div className='mt30'>
                                            <TextArea className={state.errors.education?.[key]?.educational_facility?"error":""} id="educational_facility" placeholder={t("educational_facility")} footer={t('up_to_500_words')} value={item.educational_facility??''} onChange={(e) => changeEducation(key, e)}/>
                                        </div>

                                        <div className='mt30'>
                                            <Input className={state.errors.education?.[key]?.years_studied?"error":""} id="years_studied" placeholder={t("years_studied")} value={item.years_studied??''} onChange={(e) => handleEducationNumberChange(key, e)}/>
                                        </div>

                                        {state.provider.education?.length > 1 && <div className='center-div align-items-center mt20 mb60'><div className='button-form font-30 font-bold provider-add-remove-button' onClick={(e) => removePackage(key)}>  <div className='mb5'>{t("-")}</div> </div></div>}
                                    </div>
                                 ))}

                                {state.provider.education?.length < 3 && <div className='center-div align-items-center mt20'><div className='button-form font-30 font-bold provider-add-remove-button' onClick={(e) => addPackage()}>  <div>{t("+")}</div> </div></div>}
                                <div className='button-form font-18 color-550952 mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("save")}</div> </div>
                            </div>
                        </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}